import { IMenuItem } from 'models/IMenuItem';
import styles from './styles.scss';
import connect from 'components/Shared/connect';
import { rm, NO_ELEMENT } from 'utils';
import { Main, Block } from 'components/Shared/Layout';
import cn from 'classnames';
import { shouldShowBreadcrumbs } from 'components/Shared/BreadCrumbs/selector';

interface MergedProps {
  breadCrumbs: IMenuItem[];
  homeText: string;
  showBreadcrumbs: boolean;
}

const _BreadCrumbs = ({ breadCrumbs, showBreadcrumbs }: MergedProps) =>
  showBreadcrumbs ? (
    <Main>
      <Block className={styles.breadcrumbsWrapper}>
        <div className={styles.breadcrumbs}>
          <div className={cn(styles.breadcrumb, styles.base)}>
            <a href="/">{rm('navigation_breadcrumb_startnode_title')}</a>
          </div>
          <ol itemScope itemType="https://schema.org/BreadcrumbList">
            {breadCrumbs.map((crumb, index) => (
              <li
                key={crumb.id}
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <span>/</span>
                <a href={crumb.url} itemProp="item">
                  <span itemProp="name">{crumb.title}</span>
                </a>
                <meta itemProp="position" content={`${index + 1}`} />
              </li>
            ))}
          </ol>
        </div>
      </Block>
    </Main>
  ) : (
    NO_ELEMENT
  );

export const BreadCrumbs = connect<MergedProps>(({ currentPage, location }) => ({
  showBreadcrumbs: shouldShowBreadcrumbs(location, currentPage.breadCrumbs),
  breadCrumbs: currentPage.breadCrumbs || []
}))(_BreadCrumbs);
